import { useCallback, useEffect, useState } from "react";
import APIutil from "api/APIutils";
import * as url from "api/url";
import { useSelector, useDispatch } from "react-redux";
import { getAllResources } from 'action/cultureAction';
import { apiErrorMessages } from "./constants";

export const useFetchChillerSequence = ({ equipmentId = "" }) => {
    const [state, setState] = useState({
        data: {},
        loading: false,
        error: "",
        loginError: "",
        showSubmitAlert: ""
    });
    
    // Not needed on initial loading of component, we can call manually when modal opens
    // useEffect(() => {
    //     fetchData();
    // }, []);

    const fetchData = useCallback(() => {
        setState(prevState => ({ ...prevState, loading: true }));
        APIutil.getDataAPI(`${url.getChillerSequence}/${equipmentId}/chiller-members`).then(response => {
            if (response && response.status === 200) {
                setState(prevState => ({ ...prevState, loading: false, data: response }));
            } else {
                const message = response && response.statusText ? response.statusText : "Internal application error. Please try refreshing the page."
                setState(prevState => ({ ...prevState, loading: false, error: message }));
            }
        }).catch(error => {
            const errorMessage = error.message ? error.message : "Internal application error. Please try again.";
            setState(prevState => ({ ...prevState, loading: false, error: errorMessage }));
        });
    }, [setState]);

    const onSubmit = useCallback((payload, callbackFunction) => {
        setState(prevState => ({ ...prevState, loading: true, error: "", loginError: "", showSubmitAlert: "" }));
        APIutil.postData(url.update_chiller_sequence, payload).then(response => {
            // console.log("...response", response);
            if (response && response.data && response.data.status === 200 && !response.data.errorCode) {
                callbackFunction && callbackFunction("success", {});
                setState(prevState => ({ ...prevState, loading: false, showSubmitAlert: "success", error: "Chiller sequence successfully updated. Changes to the chiller sequence can take up to 1 minute to update." }));
            } else {
                const errorMessage = response && response.data && response.data.errorCode && apiErrorMessages[response.data.errorCode] ? 
                    apiErrorMessages[response.data.errorCode] : response && response.statusText ? response.statusText : "Internal application error.";
                // To show login error message inside login modal itself
                const loginErrorMessage = response && response.data && response.data.errorCode && ["4", "5"].includes(`${response.data.errorCode}`) ? errorMessage : ""; 
                setState(prevState => ({ ...prevState, loading: false, error: loginErrorMessage ? "" : errorMessage, loginError: loginErrorMessage, showSubmitAlert: "error"  }));
                callbackFunction && callbackFunction("error", { message: errorMessage, isLoginError: loginErrorMessage !== "", showSubmitAlert: "error" });
            }
        }).catch(error => {
            const errorMessage = error.message ? error.message : "Internal application error.";
            setState(prevState => ({ ...prevState, loading: false, error: errorMessage, showSubmitAlert: "error" }));
            callbackFunction && callbackFunction("error", {...error, showSubmitAlert: "error"});
            throw error;
        });
    }, [setState]);
    
    return {
        data: state.data,
        loading: state.loading,
        error: state.error,
        loginError: state.loginError,
        showSubmitAlert: state.showSubmitAlert,
        refetch: fetchData,
        updateApiData: setState,
        onSubmit
    };
}

export const useGetLocalizationLabel = () => {
    const statusLabels = useSelector(state => state.CulturalLabelsRootReducer.Status_LabelsBasedOnPreference);
    const dispatch = useDispatch();
    useEffect(() => {
        if (statusLabels["ChillerPlantSummary.ChillerRotation.Text"] === undefined) {
            dispatch(getAllResources());
        }
    }, []);

    const getLabel = (labelKey) => {
        if (statusLabels && statusLabels[`ChillerPlantSummary.${labelKey}.Text`]) {
            return statusLabels[`ChillerPlantSummary.${labelKey}.Text`];
        } else {
            return "";
        }
    }

    const getAPIErrorLabels = (labelKey) => {
        if (statusLabels && statusLabels[`Enum.ApplicationError.${labelKey}.Text`]) {
            return statusLabels[`Enum.ApplicationError.${labelKey}.Text`];
        } else {
            return "";
        }
    }

    return {
        statusLabels,
        getLabel,
        getAPIErrorLabels
    }
}
